import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import RouterLink from 'src/components/ui/RouterLink';

const LinksDotted = ({ links, direction = 'row' }) => {
	const nodeSeparator = <Typography color="text.disabled">&bull;</Typography>;

	return (
		<Stack spacing={0.75} direction={direction} flexWrap="wrap">
			{links.map(({ label, counter, link, id }, index) => {
				let nodeSeparatorBefore, nodeSeparatorAfter;
				switch (direction) {
					case 'row':
						nodeSeparatorAfter = index + 1 < links.length && nodeSeparator;
						break;
					case 'column':
						nodeSeparatorBefore = nodeSeparator;
						break;
				}

				return (
					<Stack spacing={0.75} direction="row" key={id}>
						{nodeSeparatorBefore}
						<Link component={RouterLink} underline="none" {...link}>
							{label}
							{counter && <>&nbsp;&nbsp;{counter}</>}
						</Link>
						{nodeSeparatorAfter}
					</Stack>
				);
			})}
		</Stack>
	);
};

LinksDotted.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			counter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			link: PropTypes.shape(Link.propTypes),
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		}),
	),
	direction: PropTypes.oneOf(['row', 'column']),
};

export default LinksDotted;
